<div *ngIf="isReady">
  <button
    mat-stroked-button
    class="view-menu"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="menu"
    (menuClosed)="onClose()"
  >
    <span fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span>{{ selectedView.headerName }}</span>
      <mat-icon> arrow_drop_down</mat-icon>
    </span>
  </button>
  <mat-menu #menu="matMenu">
    <div class="view-menu-container" (keydown)="$event.stopPropagation()">
      <div class="menu-header">
        <h3>{{ title }}</h3>
        <div *ngIf="doesPlanAllowSavingViews && !hideSearch" class="search-container" appThrottleClick>
          <input type="text" class="search-input" placeholder="Find view" [(ngModel)]="searchText" />
          <mat-icon class="search-icon md-24">search</mat-icon>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div class="scrollable-section">
        <button
          *ngFor="let view of systemViews"
          mat-menu-item
          (click)="onSelectView(view)"
          [class.selected]="view.isSelected"
          aria-label="Set view as default"
        >
          <mat-icon
            *ngIf="canMarkAsDefault"
            class="pin"
            [class.material-icons-outlined]="!view.isDefault"
            appThrottleClick
            (throttledClick)="setDefault(view)"
            >push_pin</mat-icon
          >
          {{ view.name }} {{ view.isModified ? '*' : '' }}
        </button>
        <div *ngIf="doesPlanAllowSavingViews">
          <div *ngIf="myViews.length">
            <mat-divider></mat-divider>
            <h5>MY VIEWS</h5>
            <button
              *ngFor="let view of myViews | orderBy: 'name'"
              mat-menu-item
              (click)="onSelectView(view)"
              [class.selected]="view.isSelected"
            >
              <div>
                <mat-icon
                  *ngIf="canMarkAsDefault"
                  class="pin"
                  [class.material-icons-outlined]="!view.isDefault"
                  appThrottleClick
                  (throttledClick)="setDefault(view)"
                  aria-label="Set view as default"
                  >push_pin</mat-icon
                >
                {{ view.name }} {{ view.isModified ? '*' : '' }}
                <span *ngIf="view.isPublic" class="shared-tag">Shared</span>
              </div>
              <div class="item-action-buttons" *ngIf="editable">
                <mat-icon
                  color="primary"
                  appThrottleClick
                  (throttledClick)="edit.emit(view); menuTrigger.closeMenu()"
                  aria-label="Edit view"
                >
                  edit</mat-icon
                >
                <mat-icon aria-label="Delete view" color="primary" appThrottleClick (throttledClick)="onDelete(view)"
                  >delete</mat-icon
                >
              </div>
            </button>
          </div>
          <div *ngIf="sharedViews.length">
            <mat-divider></mat-divider>
            <h5>SHARED VIEWS</h5>
            <button
              *ngFor="let view of sharedViews | orderBy: 'name'"
              mat-menu-item
              (click)="onSelectView(view)"
              [class.selected]="view.isSelected"
            >
              <mat-icon
                *ngIf="canMarkAsDefault"
                class="pin"
                [class.material-icons-outlined]="!view.isDefault"
                appThrottleClick
                (throttledClick)="setDefault(view)"
                aria-label="Set view as default"
                >push_pin</mat-icon
              >
              {{ view.name }} {{ view.isModified ? '*' : '' }}
              <div class="item-action-buttons" *ngIf="canRemoveOrEdit(view)">
                <mat-icon
                  color="primary"
                  appThrottleClick
                  (throttledClick)="edit.emit(view); menuTrigger.closeMenu()"
                  aria-label="Edit view"
                >
                  edit</mat-icon
                >
                <mat-icon color="primary" appThrottleClick (throttledClick)="onDelete(view)" aria-label="Delete view"
                  >delete</mat-icon
                >
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="menu-footer" *ngIf="editable">
        <mat-divider></mat-divider>
        <button
          *ngIf="doesPlanAllowSavingViews"
          class="create-button"
          mat-menu-item
          color="primary"
          (click)="create.emit()"
        >
          CREATE NEW VIEW
        </button>
        <div *ngIf="!doesPlanAllowSavingViews" class="upgrade">
          <mat-icon>lock</mat-icon>
          <span class="upgrade-text">
            Upgrade your plan to create custom views.
            <a (click)="openTenantPlanDialog()">LEARN MORE.</a>
          </span>
        </div>
      </div>
    </div>
  </mat-menu>
</div>
